import * as request from 'request';
import * as nodemailer from 'nodemailer';
import 'dotenv/config';
import axios, {AxiosResponse, AxiosError} from 'axios';

export async function sendTextLocalSMS(mobileNo, MSG_TEMPLATE, TEMPLATE_ID) {
    let options = {
        user: process.env.BulkSMS_USER,
        password: process.env.BlkSMS_PWD,
        mobile: mobileNo,
		message:MSG_TEMPLATE,
		sender: process.env.BlkSMS_SENDER,
        type:3,
		template_id:TEMPLATE_ID,
    };
    return new Promise((resolve, reject) => {
        request.post({ url: process.env.BulkSMS_HOST, form: options }, (error: any, response: any, body: any) => {
			if (error) {
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

export async function sendMailInfo1(receiver: any, anothermsg: any, attch: any) {
	let transporter = nodemailer.createTransport({
		host: 'mail.varahasolutions.com',
 		port: 587,
		secure: false,
		auth: {
			user: 'info@varahasolutions.com',
			pass: 'Sh!vapar2021'
        },
        tls: {
            // do not fail on invalid certs
            rejectUnauthorized: false
        },
	});

	   
    let mailOptions1 = {
		from: 'info@varahasolutions.com',
		to: receiver,
		subject: 'From NetR application',
		text: '',
		html: `${anothermsg}`,
		attachments:[
			{  
				path: `${attch}`,
			},
		]
	};

    transporter.sendMail(mailOptions1, (err: any, su: { messageId: any; }) => {
		if (err) console.log(err, 'thisis  errror in mail1');
		else {
			console.log(su.messageId);
		}
	});
}

export async function sendMailInfo(receiver: any, message: any, anothermsg: any) {
	let transporter = nodemailer.createTransport({
		host: 'mail.varahasolutions.com',
 		port: 587,
		secure: false,
		auth: {
			user: 'info@varahasolutions.com',
			pass: 'Sh!vapar2021'
        },
        tls: {
            // do not fail on invalid certs
            rejectUnauthorized: false
        },
	});

	let mailOptions = {
		from: 'info@varahasolutions.com',
		to: 'info@myvdoc.in',
		subject: 'From NetR application',
		text: '',
		html: `${message}`
    };
    
    let mailOptions1 = {
		from: 'info@varahasolutions.com',
		to: receiver,
		subject: 'From NetR application',
		text: '',
		html: `${anothermsg}`
	};

	transporter.sendMail(mailOptions, (err: any, su: { messageId: any; }) => {
		if (err) console.log(err, 'thisis  errror in mail');
		else {
			console.log(su.messageId);
		}
    });
    
    transporter.sendMail(mailOptions1, (err: any, su: { messageId: any; }) => {
		if (err) console.log(err, 'thisis  errror in mail1');
		else {
			console.log(su.messageId);
		}
	});
}

/* export async function sendFCMNotifications(MSG_TEMPLATE) {
	
	const headersRequest = {
		headers:{
			"Content-Type": "application/json", // afaik this one is not needed
			"Authorization": `key=${process.env.FCM_HEADER_KEY}`,
		}
	}
	
    return new Promise((resolve, reject) => {
		axios.post(process.env.FCM_POST, MSG_TEMPLATE, headersRequest)
		.then((result) => {
			console.log(result)
		})
		.catch((error) => {
			console.log(error)
		})
		return true;
	})
		/* return new Promise((resolve, reject) => {
			request.post({ url: process.env.FCM_POST, headers:headersRequest, form: MSG_TEMPLATE }, (error: any, response: any, body: any) => {
				console.log(response);
				if (error) {
					return reject(error);
				}
				resolve({ response, body });
			});
		}); */
//}
 

export async function sendFCMNotifications(MSG_TEMPLATE) {
	let headersRequest = {
		"Content-Type": "application/json", // afaik this one is not needed
		"Authorization": "key="+process.env.FCM_HEADER_KEY,
	};
	var options = { method: 'POST',
  		url: 'https://fcm.googleapis.com/fcm/send',
  		headers: 
   		{ 
     	'content-type': 'application/json',
     	authorization: 'key='+process.env.FCM_HEADER_KEY
		},
  		body: MSG_TEMPLATE,
		icon:'myicon',
		sound:'default',
		android_channel_id:'high_importance_channel',
  		json: true 
	};
    return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			//console.log('res',response);
			//console.log('body',body)
			//console.log('hed',headersRequest)
			//console.log('input',MSG_TEMPLATE)
			if (error) {
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

/* export async function getWhatsAppGroupIds() {
	var options = {
		method: 'GET',
  		url: 'https://api.ultramsg.com/instance7116/groups',
  		headers: {'content-type': 'application/x-www-form-urlencoded'},
		qs: {
			token: 'paqi5y4fdc5m0cpc'
		}
	};

	return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			//console.log(body);
			if (error) {
				//console.log(error);
				return reject(error);
			}
			resolve({ body });
			//return body;
		});
    });
} */


export async function sendWhatsAppTxtMSG(txt:any,to:any,wkey:any,winst:any) {
	var options = {
		method: 'POST',
  		url: `https://api.ultramsg.com/${winst}/messages/chat`,
  		headers: {'content-type': 'application/x-www-form-urlencoded'},
		form: {
			token: `${wkey}`,
		  	to: `${to}`,
			body: `${txt}`,
	  		priority: '10',
	  		referenceId: ''
		}
	};

	return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			console.log(body);
			if (error) {
				console.log(error);
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

export async function sendWhatsAppImgMSG(img,cap,txt,to,wkey,winst) {
	var options = {
		method: 'POST',
  		url: `https://api.ultramsg.com/${winst}/messages/image`,
  		headers: {'content-type': 'application/x-www-form-urlencoded'},
		form: {
			token: `${wkey}`,
		  	to: `${to}`,
		  	image: `${img}`,
		  	caption: `${cap}`,
		  	body: `${txt}`,
    		priority: '10',
    		referenceId: '',
		  	nocache: ''
		}
	};

	return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			console.log(body);
			if (error) {
				console.log(error);
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}

export async function sendWhatsAppVideoMSG(img,cap,txt,to,wkey,winst) {
	var options = {
		method: 'POST',
  		url: `https://api.ultramsg.com/${winst}/messages/video`,
  		headers: {'content-type': 'application/x-www-form-urlencoded'},
		form: {
			token: `${wkey}`,
		  	to: `${to}`,
		  	video: `${img}`,
		  	caption: `${cap}`,
		  	body: `${txt}`,
    		priority: '10',
    		referenceId: '',
		  	nocache: ''
		}
	};

	return new Promise((resolve, reject) => {
        request(options, (error: any, response: any, body: any) => {
			console.log(body);
			if (error) {
				console.log(error);
				return reject(error);
			}
			resolve({ response, body });
		});
    });
}


